"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAuctionBidDtoStatusEnum = void 0;
exports.instanceOfUserAuctionBidDto = instanceOfUserAuctionBidDto;
exports.UserAuctionBidDtoFromJSON = UserAuctionBidDtoFromJSON;
exports.UserAuctionBidDtoFromJSONTyped = UserAuctionBidDtoFromJSONTyped;
exports.UserAuctionBidDtoToJSON = UserAuctionBidDtoToJSON;
exports.UserAuctionBidDtoToJSONTyped = UserAuctionBidDtoToJSONTyped;
var UserAuctionBidOfferDto_1 = require("./UserAuctionBidOfferDto");
/**
 * @export
 */
exports.UserAuctionBidDtoStatusEnum = {
    Leading: 'leading',
    UnderBid: 'under_bid',
    Won: 'won',
    Cancelled: 'cancelled',
    Withdrawn: 'withdrawn'
};
/**
 * Check if a given object implements the UserAuctionBidDto interface.
 */
function instanceOfUserAuctionBidDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('bidAmount' in value) || value['bidAmount'] === undefined)
        return false;
    if (!('userBidSequence' in value) || value['userBidSequence'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function UserAuctionBidDtoFromJSON(json) {
    return UserAuctionBidDtoFromJSONTyped(json, false);
}
function UserAuctionBidDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'bidAmount': json['bidAmount'],
        'userBidSequence': json['userBidSequence'],
        'status': json['status'],
        'createdAt': json['createdAt'],
        'offer': json['offer'] == null ? undefined : (0, UserAuctionBidOfferDto_1.UserAuctionBidOfferDtoFromJSON)(json['offer']),
    };
}
function UserAuctionBidDtoToJSON(json) {
    return UserAuctionBidDtoToJSONTyped(json, false);
}
function UserAuctionBidDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'bidAmount': value['bidAmount'],
        'userBidSequence': value['userBidSequence'],
        'status': value['status'],
        'createdAt': value['createdAt'],
        'offer': (0, UserAuctionBidOfferDto_1.UserAuctionBidOfferDtoToJSON)(value['offer']),
    };
}
